module.exports = __webpack_public_path__ + "img/202407_10.525fbba8.jpg";